import { themed } from "@tamagui/helpers-icon";
import { memo } from "react";
import { Svg, Path } from "react-native-svg";

import type { IconProps } from "@tamagui/helpers-icon";
import type { NamedExoticComponent } from "react";

const Icon = (props) => {
  const { color = "black", size = 32, ...otherProps } = props;
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      {...otherProps}
    >
      <Path
        d="M13.3333 16V11.952M18.6667 16V11.952M11.3333 28H6.66667C5.95942 28 5.28115 27.719 4.78105 27.2189C4.28095 26.7188 4 26.0406 4 25.3333V13.3333C3.99991 12.9454 4.08445 12.5622 4.24772 12.2103C4.41099 11.8584 4.64906 11.5464 4.94533 11.296L14.2787 3.29733C14.76 2.89054 15.3698 2.66736 16 2.66736C16.6302 2.66736 17.24 2.89054 17.7213 3.29733L27.0547 11.296C27.3509 11.5464 27.589 11.8584 27.7523 12.2103C27.9156 12.5622 28.0001 12.9454 28 13.3333V25.3333C28 26.0406 27.719 26.7188 27.2189 27.2189C26.7189 27.719 26.0406 28 25.3333 28H18.6667C17.9594 28 17.2811 27.719 16.781 27.2189C16.281 26.7188 16 26.0406 16 25.3333V22.6667M20 16C20.3536 16 20.6928 16.1405 20.9428 16.3905C21.1929 16.6406 21.3333 16.9797 21.3333 17.3333V20C21.3333 20.7072 21.0524 21.3855 20.5523 21.8856C20.0522 22.3857 19.3739 22.6667 18.6667 22.6667H13.3333C12.6261 22.6667 11.9478 22.3857 11.4477 21.8856C10.9476 21.3855 10.6667 20.7072 10.6667 20V17.3333C10.6667 16.9797 10.8071 16.6406 11.0572 16.3905C11.3072 16.1405 11.6464 16 12 16H20Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

Icon.displayName = "ElectricityHome";

export const ElectricityHome: NamedExoticComponent<IconProps> = memo<IconProps>(
  themed(Icon),
);
